import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Navbar } from '@/components/generals/navbar'
import { Footer } from '@/components/generals/footer'
import { useReveal } from '@/hooks/use-reveal'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    useReveal()

    return (
        <>
            <Navbar />

            <div className='page' data-main=''>
                <main>
                    {children}
                </main>

                <Footer />
            </div>
        </>
    )
}
